import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
const HERO_IMAGE = "image.png";

export const Hero = ({ isDesktop, THEME }) => {
 
  return (
    <section
      id="hero"
      style={{
        position: "relative",
        width: "100%",
        height: "95vh",
        paddingLeft: isDesktop ? "10px" : "0",
        paddingTop: isDesktop ? "0" : "80px",
        overflow: "hidden",
        backgroundColor: "#18181b",
        boxSizing: "border-box",
      }}
    >
      {/* Background Image with Overlay */}
      <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
        <img
          src={HERO_IMAGE}
          alt="Industrial Automotive Manufacturing"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.6,
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to right, rgba(9,9,11,0.95), rgba(9,9,11,0.6), transparent)",
          }}
        ></div>
      </div>

      {/* Grid Lines (Desktop Only) */}
      {isDesktop && (
        <>
          <div
            style={{
              position: "absolute",
              bottom: "50px",
              left: 0,
              right: 0,
              height: "1px",
              backgroundColor: "rgba(230, 230, 230, 0.8)",
              zIndex: 10,
              pointerEvents: "none",
            }}
          ></div>

          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: "-200px",
              borderLeft: "1px solid rgba(230, 230, 230, 0.8)",
              zIndex: 10,
              pointerEvents: "none",
              marginLeft: "280px",
            }}
          ></div>

          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              right: "500px",
              borderLeft: "1px solid rgba(230, 230, 230, 0.8)",
              zIndex: 10,
              pointerEvents: "none",
              marginLeft: "280px",
            }}
          ></div>
        </>
      )}

      {/* Hero Text Content */}
      <div
        style={{
          position: "relative",
          zIndex: 20,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: isDesktop ? "0 96px" : "0 24px",
          boxSizing: "border-box",
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          style={{ maxWidth: "896px" }}
        >
          {/* Subheading */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "4px",
            }}
          >
            {/* Gold Accent Line */}
            <div
              style={{
                width: "48px",
                height: "2px",
                backgroundColor: THEME.colors.accent,
              }}
            ></div>
            <p
              style={{
                color: THEME.colors.accent,
                fontWeight: "bold",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                fontSize: isDesktop ? "16px" : "14px",
                margin: 0,
              }}
            >
              Since 1984 • IATF 16949 Certified
            </p>
          </div>

          {/* Main Headline */}
          <h1
            style={{
              fontSize: isDesktop ? "96px" : "48px", // Responsive Font Size
              fontWeight: 900,
              color: "white",
              textTransform: "uppercase",
              lineHeight: 0.9,
              letterSpacing: "-2px",
              marginBottom: "32px",
              marginTop: 0,
              fontFamily: THEME.fonts.body,
            }}
          >
            Engineered <br />
            To <span style={{ color: "#a1a1aa" }}>Shine.</span> <br />
            <span
              style={{
                color: "transparent",
                WebkitTextStroke: isDesktop ? "2px white" : "1px white",
              }}
            >
              Built To Last.
            </span>
          </h1>

          <p
            style={{
              color: THEME.colors.textMuted,
              fontSize: isDesktop ? "20px" : "18px",
              maxWidth: "576px",
              marginBottom: "48px",
              lineHeight: 1.6,
              borderLeft: `2px solid ${THEME.colors.primary}`,
              paddingLeft: "24px",
              // margin: "0 0 48px 0",
            }}
          >
            India's automotive lighting manufacturer since 1984. IATF 16949
            certified excellence in automotive and defence lighting solutions.
          </p>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: isDesktop ? "row" : "column",
              alignItems: isDesktop ? "center" : "flex-start",
              gap: "24px",
            }}
          >
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#products"
              style={{
                backgroundColor: THEME.colors.primary,
                color: "white",
                border: "none",
                padding: "16px 40px",
                fontWeight: "bold",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                cursor: "pointer",
                boxShadow: "0 10px 15px -3px rgba(185, 28, 28, 0.2)",
              }}
            >
              Explore Products
              <ArrowRight size={16} />
            </motion.a>

            <Link
              to={"/rfq"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                textDecoration: "none",
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderTop: "6px solid transparent",
                    borderBottom: "6px solid transparent",
                    borderLeft: "10px solid white",
                    marginLeft: "4px",
                  }}
                ></div>
              </div>
              <span
                style={{
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  fontSize: "12px",
                }}
              >
                Get a Quote
              </span>
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Bottom Scroll Indicator (Desktop Only) */}
      {isDesktop && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          // transition={{ delay: 1.2 }}
          style={{
            position: "absolute",
            bottom: "24px",
            right: "280px",
            zIndex: 20,
            pointerEvents: "none",
          }}
        >
          <motion.div
            animate={{ y: [-40, 8, -40] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.25em",
              textTransform: "uppercase",
            }}
          >
            Scroll Down
            <ChevronDown size={16} />
          </motion.div>
        </motion.div>
      )}
    </section>
  );
};

// <div style={{ display: "flex", gap: "32px", alignItems: "center" }}>
//   <div style={{ color: "white", fontWeight: "bold", fontSize: "20px" }}>01</div>
//   <div
//     style={{
//       width: "128px",
//       height: "2px",
//       backgroundColor: "rgba(255,255,255,0.2)",
//       position: "relative",
//     }}
//   >
//     {/* Gold Progress Bar */}
//     <div
//       style={{
//         position: "absolute",
//         top: 0,
//         left: 0,
//         height: "100%",
//         width: "33%",
//         backgroundColor: THEME.colors.accent,
//       }}
//     ></div>
//   </div>
//   <div
//     style={{
//       color: "rgba(255,255,255,0.4)",
//       fontWeight: "bold",
//       fontSize: "20px",
//     }}
//   >
//     05
//   </div>
// </div>;
